export default "__VITE_ASSET__55coYQB6__"